import { z } from 'zod';

import { TSDSchema } from './TSDSchema';

export const TSDEditDataSchema = z.object({
  tsd: TSDSchema,
  refreshCustomerData: z.boolean().optional(),
});
export type TSDEditData = z.infer<typeof TSDEditDataSchema>;
